module.exports = __webpack_public_path__ + "img/terroir-redshift-1-mobile.0428a769.jpg";